import { render, staticRenderFns } from "./item_font.vue?vue&type=template&id=9f7e0618&scoped=true&lang=pug&"
import script from "./item_font.vue?vue&type=script&lang=js&"
export * from "./item_font.vue?vue&type=script&lang=js&"
import style0 from "./item_font.vue?vue&type=style&index=0&id=9f7e0618&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7e0618",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('9f7e0618', component.options)
    } else {
      api.reload('9f7e0618', component.options)
    }
    module.hot.accept("./item_font.vue?vue&type=template&id=9f7e0618&scoped=true&lang=pug&", function () {
      api.rerender('9f7e0618', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/design_token/item_font.vue"
export default component.exports